module.exports = __webpack_public_path__ + "img/stop.e867fbc1.png";